import { render, staticRenderFns } from "./waveform.vue?vue&type=template&id=7b59d30f"
import script from "./waveform.vue?vue&type=script&lang=js"
export * from "./waveform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports